import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import axiosInstance from "../../../axios/axiosInstance";
import { notify } from "../../../utils/notification";
import {logOut} from '../../../utils/helpers/logout'
import apiEndpoints from "../../../axios/api";
import * as types from "../../constants";
import moment from "moment";
import { notesFilePath } from "../../../firebase/getFirebasePath";
import { deleteImageFromFirebase, getFirebaseURL, uploadImageOnFirebase } from "../../../firebase/firebaseFunction";
import { logger } from "../../../utils/logging";

export const getConsultationNotesReq = async({data})=>{   
    const BODY={
        user_id: data.guestId,
        user_program_id: data.userProgramId,
        date: data.date,
        notes_type: data.noteType
    }
    return axiosInstance.post(`${apiEndpoints.VIEW_CONSULTATION_NOTES_API}`, {data: BODY})
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);

            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            }else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* getConsultationNotes({data}){
    try{
        let result = yield call(getConsultationNotesReq, {data})
        if(result.statusCode === 200){
            result.data.list = !result.data.list ? [] : yield Promise.all(result.data.list.map(async noteGroup => {
                return {
                    ...noteGroup,
                    list: !noteGroup.list ? [] : await Promise.all(noteGroup.list.map(async note => {
                        let parsed = note.notes_doc ? JSON.parse(note.notes_doc) : [];
                        const notes_url = await Promise.all(parsed.map(async item => {
                            return await getFirebaseURL(item);
                        }));

                        let parsedDocs = note.docs ? JSON.parse(note.docs) : [];
                        const urls = await Promise.all(parsedDocs.map(async item => {
                            return await getFirebaseURL(item);
                        }));
                        return {
                            ...note,
                            notes_doc: parsed,
                            docs: parsedDocs,
                            docs_url: urls,
                            notes_url: notes_url 
                        };
                    }))
                };
            }));
            yield put({ type: types.GET_CONSULTATION_NOTES_DATA_SUCCESS, payload: result.data});  
        }else{
            yield put({ type: types.GET_CONSULTATION_NOTES_DATA_FALIURE});
        }
    }catch(error){
        logger.log(error)
        yield put({ type: types.GET_CONSULTATION_NOTES_DATA_FALIURE, message: error.message });
    }
}


export const getNotesTypeReq = async({data})=>{   
    return axiosInstance.get(`${apiEndpoints.GET_NOTES_TYPE_LIST_API}`)
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);

            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            }else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* getNotesType({data}){
    try{
        let result = yield call(getNotesTypeReq, {data})
        if(result.statusCode === 200){
            yield put({ type: types.GET_NOTES_TYPE_LIST_SUCCESS, payload: result.data});  
        }else{
            yield put({ type: types.GET_NOTES_TYPE_LIST_FALIURE});
        }
    }catch(error){
        yield put({ type: types.GET_NOTES_TYPE_LIST_FALIURE, message: error.message });
    }
}

export const deleteConsultationNotesReq = async({data})=>{
    const BODY = {
        "note_id": data.noteId
      }

    return axiosInstance.delete(apiEndpoints.DELETE_CONSULTATION_NOTES_API, { data: {data: BODY} })
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);
            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* deleteConsultationNotes({data}){
    try{
        let result = yield call(deleteConsultationNotesReq, {data})

        if(result.statusCode === 200){
            for(let i=0; i<data.docs?.length; i++){
                let filePath = data.docs[i];
                yield call(deleteImageFromFirebase, filePath)
            }

            //getting notes list
            let noteList = yield call(getConsultationNotesReq, {
                data: {
                    guestId: data.guestId,
                    userProgramId: data.userProgramId,
    
                }
            })
            noteList.data.list = !noteList.data.list ? [] : yield Promise.all(noteList.data.list.map(async noteGroup => {
                return {
                    ...noteGroup,
                    list: !noteGroup.list ? [] : await Promise.all(noteGroup.list.map(async note => {
                        let parsed = note.notes_doc ? JSON.parse(note.notes_doc) : [];
                        const notes_url = await Promise.all(parsed.map(async item => {
                            return await getFirebaseURL(item);
                        }));
        
                        let parsedDocs = note.docs ? JSON.parse(note.docs) : [];
                        const urls = await Promise.all(parsedDocs.map(async item => {
                            return await getFirebaseURL(item);
                        }));
        
                        return {
                            ...note,
                            notes_doc: parsed,
                            docs: parsedDocs,
                            docs_url: urls,
                            notes_url: notes_url 
                        };
                    }))
                };
            }))
            yield put({ type: types.GET_CONSULTATION_NOTES_DATA_SUCCESS, payload: noteList.data});  

            // yield put({ type: types.DEL_CONSULTATION_NOTES_DATA_SUCCESS, payload: data});
            notify("success", result.message)
        }
    }catch(error){
        console.log(error);
    }
}

export const updateConsultationNotesVisibleStatusReq = async({data})=>{
    const BODY = {
        "user_program_note_id": data.noteId,
        "is_guest_visible": data.isVisible ? 1 : 0
    }
    return axiosInstance.put(apiEndpoints.UPDATE_VISIBLE_STATUS_CONSULTATION_NOTES_API, {data: BODY})
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);
            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            }else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* updateConsultationNotesVisibleStatus({data}){
    try{
        let result = yield call(updateConsultationNotesVisibleStatusReq, {data})
        if(result.statusCode === 200){
            yield put({ type: types.UPDATE_CONSULTATION_NOTES_VISIBLE_STATUS_SUCCESS, payload: data});
            notify("success", result.message)
        }
    }catch(error){
        logger.log(error)
    }
}

export const addConsultationNotesReq = async({data})=>{
    const BODY = {
        "user_id": data?.guestId,
        "user_program_id": data?.userProgramId,
        "visible_status": data?.isVisible ? 1: 0,
        "session_id": data?.sessionId || 0,
        "notes_detail": data?.content,
        "notes_type": data?.noteType,
        "notes_doc": data?.docsPath,
        "date_time": data?.date + moment().format(" HH:mm:ss")
      }

    return axiosInstance.post(apiEndpoints.ADD_CONSULTATION_NOTES_API, { data: BODY})
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);
            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            }else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* addConsultationNotes({data}){
    try{
        let docsPath=[]
        for(let i=0; i<data.files.newFiles?.length; i++){
            let filePath = notesFilePath({fileName: data.files.newFiles[i].name});
            yield call(uploadImageOnFirebase, data.files.newFiles[i], filePath)
            docsPath.push(filePath)
        }
        data.docsPath=docsPath;
        let result = yield call(addConsultationNotesReq, {data})

        if(result.statusCode === 200){
            yield put({ type: types.ADD_CONSULTATION_NOTES_DATA_SUCCESS }); 
            window.history.back();
            notify('success', result.message);
        }else{
            yield put({ type: types.ADD_CONSULTATION_NOTES_DATA_FALIURE }); 
        }
    }catch(error){
        logger.log(error)
        yield put({ type: types.ADD_CONSULTATION_NOTES_DATA_FALIURE }); 
    }
}

export const updateConsultationNotesReq = async({data})=>{
    const BODY = {
        "user_program_note_id": data?.noteId,
        "is_guest_visible": data?.isVisible ? 1: 0,
        "notes_detail": data?.content,
        "session_id": data?.sessionId || 0,
        "notes_doc": data?.docsPath,
        "date_time": moment().format("YYYY-MM-DD HH:mm:ss")
      }

    return axiosInstance.put(apiEndpoints.UPDATE_CONSULTATION_NOTES_API, { data: BODY})
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);
            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            }else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* updateConsultationNotes({data}){
    try{
        let docsPath=[...data.files.uploadedFiles]
        for(let i=0; i<data.files.newFiles?.length; i++){
            let filePath = notesFilePath({fileName: data.files.newFiles[i].name});
            yield call(uploadImageOnFirebase, data.files.newFiles[i], filePath)
            docsPath.push(filePath)
        }

        for(let i=0; i<data.files.removedUploadedFiles?.length; i++){
            let filePath = data.files.removedUploadedFiles[i];
            yield call(deleteImageFromFirebase, filePath)
        }

        data.docsPath=docsPath;
        let result = yield call(updateConsultationNotesReq, {data})

        if(result.statusCode === 200){
            yield put({ type: types.UPDATE_CONSULTATION_NOTES_DATA_SUCCESS }); 
            window.history.back();
            notify('success', result.message);
        }else{
            yield put({ type: types.UPDATE_CONSULTATION_NOTES_DATA_FALIURE }); 
        }
    }catch(error){
        logger.log(error)
        yield put({ type: types.UPDATE_CONSULTATION_NOTES_DATA_FALIURE }); 
    }
}


export const getPreviousNoteReq = async({data})=>{   
    return axiosInstance.get(`${apiEndpoints.GET_PREVIOUS_CONSULTATION_NOTE_BY_TYPE_API}?notes_type=${data.noteType}&user_program_id=${data.userProgramId}`)
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);

            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            }else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* getPreviousNote({data}){
    try{
        let result = yield call(getPreviousNoteReq, {data})
        if(result.statusCode === 200){
            yield put({ type: types.GET_PREVIOUS_CONSULTATION_NOTE_BY_TYPE_SUCCESS, payload: result.data});  
        }else{
            yield put({ type: types.GET_PREVIOUS_CONSULTATION_NOTE_BY_TYPE_FALIURE});
        }
    }catch(error){
        yield put({ type: types.GET_PREVIOUS_CONSULTATION_NOTE_BY_TYPE_FALIURE, message: error.message });
    }
}

export const getLabTestsReq = async({data})=>{   
    return axiosInstance.get(`${apiEndpoints.GET_LAB_TEST_LIST_API}?static=${data?.isStatic ? 1 : 0}${data?.categoryGroup ? '&category_group=1' : ''}`)
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);

            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            }else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* getLabTests({data}){
    try{
        let result = yield call(getLabTestsReq, {data})
        if(result.statusCode === 200){
            yield put({ type: data?.isStatic ? types.GET_STATIC_LAB_TESTS_SUCCESS : types.GET_LAB_TESTS_SUCCESS, payload: result.data});  
        }else{
            yield put({ type: data?.isStatic ? types.GET_STATIC_LAB_TESTS_FALIURE : types.GET_LAB_TESTS_FALIURE});
        }
    }catch(error){
        logger.log(error);
        yield put({ type: types.GET_LAB_TESTS_FALIURE, message: error.message });
    }
}


export const downloadNotesExcelReq = async({data})=>{   

  return axiosInstance.get(`${apiEndpoints.DOWNLOAD_CONSULTATION_NOTES_EXCEL_API}?cron_key=187&download_req=true`, {
      responseType: 'arraybuffer',
  })
      .then(response => {
          return response;
      }).catch((errors) => {
          logger.log("errors", errors);

          if (errors.response?.data.statusCode === 400) {
              logger.log(errors.response.data.message);
          } else if(errors.response.data.statusCode === 401){
              logOut();
          }else {
              notify('warning', "Something went wrong");
          }
          return errors
      })
}

function* downloadNotesExcel({data}){
  try{
      let result = yield call(downloadNotesExcelReq, {data})
      if(result.data instanceof ArrayBuffer){
          yield put({ type: types.DOWNLOAD_CONSULTATION_NOTES_EXCEL_SUCCESS, payload: result.data});  
          data?.onSuccessCallback(result.data)
      } else{
          yield put({ type: types.DOWNLOAD_CONSULTATION_NOTES_EXCEL_FALIURE,});  
      }        
  }catch(error){
      yield put({ type: types.DOWNLOAD_CONSULTATION_NOTES_EXCEL_FALIURE, message: error.message });
      logger.log(error)

  }
}

export const getSessionListAgainstToNotesReq = async({data})=>{   
    return axiosInstance.get(`${apiEndpoints.GET_SESSION_LIST_AGAINST_TO_NOTES_API}?user_program_id=${data.userProgramId}&notes_type=${data.noteType}`)
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);

            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            }else {
                // notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* getSessionListAgainstToNotes({data}){
    try{
        let result = yield call(getSessionListAgainstToNotesReq, {data})
        if(result.statusCode === 200){
            yield put({ type: types.GET_SESSION_LIST_AGAINST_TO_NOTES_SUCCESS, payload: result.data});  
        }else{
            yield put({ type: types.GET_SESSION_LIST_AGAINST_TO_NOTES_FALIURE});
        }
    }catch(error){
        yield put({ type: types.GET_SESSION_LIST_AGAINST_TO_NOTES_FALIURE, message: error.message });
    }
}


export const downloadPendingNotesExcelReq = async({data})=>{   

    return axiosInstance.get(`${apiEndpoints.DOWNLOAD_PENDING_NOTES_EXCEL_API}?cron_key=187&is_download_req=1`, {
        responseType: 'arraybuffer',
    })
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);
  
            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            }else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
  }
  
function* downloadPendingNotesExcel({data}){
    try{
        let result = yield call(downloadPendingNotesExcelReq, {data})
        if(result.data instanceof ArrayBuffer){
            yield put({ type: types.DOWNLOAD_PENDING_NOTES_EXCEL_SUCCESS, payload: result.data});  
            data?.onSuccessCallback(result.data)
        } else{
            yield put({ type: types.DOWNLOAD_PENDING_NOTES_EXCEL_FALIURE,});  
        }        
    }catch(error){
        yield put({ type: types.DOWNLOAD_PENDING_NOTES_EXCEL_FALIURE, message: error.message });
        logger.log(error)
  
    }
  }


function* consultationNotesSaga(){
    yield takeLatest(types.GET_CONSULTATION_NOTES_DATA, getConsultationNotes);
    yield takeLatest(types.GET_NOTES_TYPE_LIST, getNotesType);
    yield takeLatest(types.DEL_CONSULTATION_NOTES_DATA, deleteConsultationNotes);
    yield takeLatest(types.UPDATE_CONSULTATION_NOTES_VISIBLE_STATUS, updateConsultationNotesVisibleStatus);
    yield takeLatest(types.ADD_CONSULTATION_NOTES_DATA, addConsultationNotes);
    yield takeLatest(types.UPDATE_CONSULTATION_NOTES_DATA, updateConsultationNotes);
    yield takeLatest(types.GET_PREVIOUS_CONSULTATION_NOTE_BY_TYPE, getPreviousNote);
    yield takeEvery(types.GET_LAB_TESTS, getLabTests);
    yield takeLatest(types.DOWNLOAD_CONSULTATION_NOTES_EXCEL, downloadNotesExcel);
    yield takeLatest(types.GET_SESSION_LIST_AGAINST_TO_NOTES, getSessionListAgainstToNotes);
    yield takeLatest(types.DOWNLOAD_PENDING_NOTES_EXCEL, downloadPendingNotesExcel);

}

export default consultationNotesSaga;